<header>
  <span>WARNING</span>
  <oph-x-button (buttonClick)="onClose()"></oph-x-button>
</header>

@if (customData?.title) {
  <p>{{ customData.title }}</p>
} @else {
  <p>
    Are you sure you want to permanently delete the following {{ type | titlecase }}?
    {{ type === 'challenge' && 'All your prior cycle data will be lost.' }}
  </p>
}

@if (type === 'tracker') {
  <div class="display-container">
    <span class="name">{{ tracker?.name || '' }}</span>
    <span class="metric-count ml-15">{{ tracker?.metrics?.length || 0 }} Metrics</span>
  </div>
}

@if (type === 'metric') {
  <div class="display-container metric-display-container">
    <div class="display-container-row">
      <span class="name">{{ metric?.name || 'Untitled' }}</span>
    </div>
    <div class="display-container-row mw-360">
      <div class="display-item">
        <label>CURRENT</label>
        <span>{{ metric?.value || 'Undefined' }}</span>
      </div>
      <div class="display-item">
        <label>TYPE</label>
        <span>{{ metric?.type | trackerMetricTypeDisplay | titlecase }}</span>
      </div>
      <div class="display-item">
        <label>DEFAULT</label>
        <span>{{ metric?.defaultValue || 'Undefined' }}</span>
      </div>
    </div>
  </div>
}

@if (type === 'user') {
  <div class="display-container">
    <span class="name">{{ user?.username || 'Username not found' }}</span>
  </div>
}

@if (type === 'project') {
  <div class="display-container">
    <span class="name">{{ project?.label || '' }}</span>
    <span class="metric-count ml-15">{{ taskCount || 0 }} Tasks</span>
  </div>
}

@if (type === 'challenge') {
  <div class="display-container">
    <span class="name">{{ project?.label || '' }}</span>
  </div>
}

@if (type === 'custom') {
  <div class="display-container">
    <span class="name">{{ customData?.message || 'Custom message not found' }}</span>
  </div>
}

<footer>
  <oph-button
    appearance="outline"
    color="gray"
    (buttonClick)="onClose()"
    [style]="{height: '36px', 'border-radius': '6px', padding: '0 16px'}"
  >
    {{ customData.cancelText }}
  </oph-button>
  <oph-button
    color="red"
    (click)="onClose(true)"
    [style]="{height: '36px', 'border-radius': '6px', padding: '0 16px', width: '110px'}"
    [loading]="loading"
  >
    {{ customData.confirmText }}
  </oph-button>
</footer>
